export default __webpack_public_path__ + "static/media/TVinsure-Benefit-of-Insurance-new.ce47259a.png";